<div class="custom-dropdown-wrapper" id="custom-dropdown-wrapper">
  <div class="triangle" id="triangle"></div>
  <div class="custom-dropdown">
    <ng-content></ng-content>
  </div>
</div>
